import React from 'react';
import Select from '@/Framework/UI/Molecules/Form/Select/legacy';
import ReduxFormSelect from '@/Framework/UI/Molecules/Form/Select/legacy/ReduxFormSelect';
import styles from './currenciesSelect.scss';

interface IProps {
  name: string,
  value: string,
  onChange: (selectedCurrency: any) => void,
  onBlur?: () => void,
  label?: string,
  disabled: boolean,
  isNarrow: boolean,
  options: any[],
}

function CurrenciesSelect(props: IProps) {
  const Component = ('input' in props) ? ReduxFormSelect : Select;
  const optionsWithFlags = props.options.map((item) => ({
    ...item,
    className: styles.currencyOption,
    label: (
      <>
        <span className={ styles.currencyOptionFlag } dangerouslySetInnerHTML={ { __html: item.icon } } />
        <span className={ styles.currencyOptionLabel }>{ item.label }</span>
      </>
    ),
  }));

  return (
    // @ts-ignore
    <Component
      { ...props }
      isNarrow
      searchable={ false }
      options={ optionsWithFlags }
      supportHighlighting={ false }
      dataTest="currency"
    />
  );
}

export default CurrenciesSelect;
